<div class="offline" *ngIf="!online" role="alertdialog" aria-live="assertive">
  <div class="ui-card offline__card">
    <div class="ui-card__body">
      <span class="ui-badge ui-badge--sm offline__badge">Offline</span>
      <h2 class="offline__title">You've lost your internet connection</h2>
      <p class="ui-hint ui-hint--muted offline__copy">
        The app needs a connection to keep working. It will reload on its own
        as soon as you're back online.
      </p>
    </div>
  </div>
</div>
